import Clickable from '@ms/yammer-web-core-ui/dist/components/Clickable';
import { getFirstFocusable } from '@ms/yammer-web-core-ui/dist/util/getFirstFocusable';
import type { FC } from 'react';
import React from 'react';

export interface FocusMainContentButtonProps {
  readonly text: string;
}

const focusMainElement = () => {
  const main = document.querySelector('main, [role="main"]') as HTMLElement | null;
  if (!main) {
    return;
  }

  const isMainFocusable = main.getAttribute('tabIndex') != null;
  if (main && isMainFocusable) {
    main.focus();

    return;
  }

  const firstFocusable: HTMLElement | null = getFirstFocusable(main, main);
  if (firstFocusable) {
    firstFocusable.focus();
  }
};

const FocusMainContentButton: FC<FocusMainContentButtonProps> = ({ text }) => (
  <Clickable onClick={focusMainElement}>{text}</Clickable>
);

export default FocusMainContentButton;
